<div
  class="hd-gate-line-duality"
  [class.hd-gate-line-duality--exaltation]="kind() === 'exaltation'"
  [class.hd-gate-line-duality--detriment]="kind() === 'detriment'"
  [class.hd-gate-line-duality--fixed]="emphasis() === 'fixed'"
  [class.hd-gate-line-duality--dimmed]="emphasis() === 'dimmed'"
  [class.hd-gate-line-duality--unfixed]="emphasis() === 'unfixed'"
  [class.hd-gate-line-duality--origin-chart]="fixationOrigins().includes('chart')"
  [class.hd-gate-line-duality--origin-transit]="fixationOrigins().includes('transit')"
>
  <div class="hd-gate-line-duality__marker">
    @if (row().glyphChar) {
      <span
        class="hd-gate-line-duality__glyph"
        [title]="fixationCauseTooltip() || row().planetName"
        [attr.aria-label]="fixationCauseTooltip() || row().planetName"
      >{{ row().glyphChar }}</span>
    }
    <span
      class="hd-gate-line-duality__triangle"
      [title]="fixationCauseTooltip() || null"
      [attr.aria-label]="fixationCauseTooltip() || null"
      [attr.aria-hidden]="fixationCauseTooltip() ? null : 'true'"
    >{{ kind() === 'exaltation' ? '▲' : '▼' }}</span>
  </div>

  <div class="hd-gate-line-duality__text">
    @if (showRa() && (row().keynoteWhite || row().keynoteBlack)) {
      <p class="hd-gate-line-duality__keynotes">
        @if (row().keynoteWhite) {
          <span class="hd-gate-line-duality__keynote-white">{{ row().keynoteWhite }}</span>
        }
        @if (row().keynoteWhite && row().keynoteBlack) {
          <span class="hd-gate-line-duality__sep"> | </span>
        }
        @if (row().keynoteBlack) {
          <span class="hd-gate-line-duality__keynote-black">{{ row().keynoteBlack }}</span>
        }
      </p>
    }

    @if (showCustom() && row().customInterpretation) {
      <p class="hd-gate-line-duality__custom">~ {{ row().customInterpretation }}</p>
    }

    @if (showOwn() && row().ownInterpretation) {
      <!-- Eigen tekst (Mechanics in Motion): achter een amber ◆, met reviewknoppen voor wie mag reviewen. -->
      <hd-own-line-text class="hd-gate-line-duality__own" [gate]="gate()" [line]="line()" [field]="kind()" [text]="row().ownInterpretation" />
    }
  </div>
</div>
